export default __webpack_public_path__ + "static/media/user.ef5ae3b3.svg";